import DoodleEyesYeux1 from './yeux-1';
import DoodleEyesYeux2 from './yeux-2';
import DoodleEyesYeux3 from './yeux-3';
import DoodleEyesYeux4 from './yeux-4';
import DoodleEyesYeux5 from './yeux-5';
import DoodleEyesYeux6 from './yeux-6';
import DoodleEyesYeux7 from './yeux-7';
import DoodleEyesYeux8 from './yeux-8';
import DoodleEyesYeux9 from './yeux-9';
import DoodleEyesYeux10 from './yeux-10';
import DoodleEyesYeux11 from './yeux-11';

export {
	DoodleEyesYeux1,
	DoodleEyesYeux2,
	DoodleEyesYeux3,
	DoodleEyesYeux4,
	DoodleEyesYeux5,
	DoodleEyesYeux6,
	DoodleEyesYeux7,
	DoodleEyesYeux8,
	DoodleEyesYeux9,
	DoodleEyesYeux10,
	DoodleEyesYeux11
};

// keys are saved in doodle configurations: never rename or remove one
export const DoodleEyesParts = {
	'yeux-1': DoodleEyesYeux1,
	'yeux-2': DoodleEyesYeux2,
	'yeux-3': DoodleEyesYeux3,
	'yeux-4': DoodleEyesYeux4,
	'yeux-5': DoodleEyesYeux5,
	'yeux-6': DoodleEyesYeux6,
	'yeux-7': DoodleEyesYeux7,
	'yeux-8': DoodleEyesYeux8,
	'yeux-9': DoodleEyesYeux9,
	'yeux-10': DoodleEyesYeux10,
	'yeux-11': DoodleEyesYeux11
};

export type DoodleEyesKey = keyof typeof DoodleEyesParts;
